import { render } from "./RubricEdit.vue?vue&type=template&id=5eac6d68"
import script from "./RubricEdit.vue?vue&type=script&lang=js"
export * from "./RubricEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__